import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/TEMPO-Logo-Small.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "snackbar-alert-ul" }
const _hoisted_3 = ["data-date"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { id: "menu-area" }
const _hoisted_6 = {
  style: {"font-weight":"normal"},
  tabindex: "0",
  href: "https://www.cosmicds.cfa.harvard.edu/resources/tempo",
  target: "_blank",
  rel: "noopener"
}

import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";
import { supportsTouchscreen } from "@cosmicds/vue-toolkit";

import { useTempoStore } from "@/stores/app";
import changes from "@/changes";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  emits: ["intro-slide"],
  setup(__props, { emit: __emit }) {

library.add(faArrowsRotate);

const emit = __emit;

const store = useTempoStore();
const {
  accentColor2,
  shareButtonClickedCount,
} = storeToRefs(store);

const display = useDisplay();

const currentUrl = ref(window.location.href);
const showChanges = ref(false);
const showAboutData = ref(false);
const showCredits = ref(false);

const touchscreen = supportsTouchscreen();

const smallSize = computed(() => {
  return display.smAndDown.value;
});


const mobile = computed(() => {
  return smallSize.value && touchscreen;
});

return (_ctx: any,_cache: any) => {
  const _component_cds_dialog = _resolveComponent("cds-dialog")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_share_button = _resolveComponent("share-button")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { id: "logo-title" }, [
      _createElementVNode("a", {
        href: "https://tempo.si.edu",
        target: "_blank",
        rel: "noopener noreferrer"
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "TEMPO Logo",
          style: {"width":"100px","height":"100px"}
        })
      ])
    ], -1)),
    _cache[26] || (_cache[26] = _createElementVNode("h1", { id: "title" }, "TEMPO Lab: Investigate Air Quality", -1)),
    _createVNode(_component_cds_dialog, {
      title: "What's new",
      modelValue: showChanges.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showChanges).value = $event)),
      color: _unref(accentColor2)
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(changes), (change) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "change-item mb-5",
              key: change.date,
              "data-date": change.date
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle({"font-weight":"bold", "color": `${change.highlight ? "var(--smithsonian-yellow)" : "currentColor"}` })
              }, _toDisplayString(change.date), 5),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _cache[15] || (_cache[15] = _createTextVNode()),
              _createElementVNode("span", {
                innerHTML: change.html
              }, null, 8, _hoisted_4),
              _createTextVNode(_toDisplayString(change.text), 1)
            ], 8, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "color"]),
    _createElementVNode("div", _hoisted_5, [
      ((new Date('2025-05-7 00:00:00') > new Date()))
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "whats-new-button pulse",
            "aria-label": "What's new",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showChanges.value = true)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (showChanges.value = true), ["enter"])),
            variant: "outlined",
            rounded: "lg",
            color: _unref(accentColor2),
            elevation: "0",
            size: "lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                activator: "parent",
                disabled: mobile.value,
                text: "What's new"
              }, null, 8, ["disabled"]),
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("mdi-creation", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color"]))
        : _createCommentVNode("", true),
      _createVNode(_component_share_button, {
        source: currentUrl.value,
        buttonColor: "black",
        iconColor: _unref(accentColor2),
        elevation: "0",
        size: "small",
        rounded: "1",
        "tooltip-disabled": mobile.value,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (shareButtonClickedCount.value += 1)),
        alert: ""
      }, null, 8, ["source", "iconColor", "tooltip-disabled"]),
      _createVNode(_component_v_btn, {
        "aria-role": "menu",
        "aria-label": "Show menu",
        class: "menu-button",
        variant: "outlined",
        rounded: "lg",
        color: _unref(accentColor2),
        elevation: "5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "x-large" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("mdi-menu", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_menu, { activator: "parent" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    tabindex: "0",
                    "aria-label": "See recent changes",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showChanges.value = true)),
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (showChanges.value = true), ["enter"]))
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode(" What's New ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    tabindex: "0",
                    "aria-label": "Show introduction",
                    onClick: _cache[6] || (_cache[6] = () => emit('intro-slide', 1)),
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(() => emit('intro-slide', 1), ["enter"]))
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode(" Introduction ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    tabindex: "0",
                    "aria-label": "Show user guide",
                    onClick: _cache[8] || (_cache[8] = () => emit('intro-slide', 4)),
                    onKeyup: _cache[9] || (_cache[9] = _withKeys(() => emit('intro-slide', 4), ["enter"]))
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode(" User Guide ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    tabindex: "0",
                    "aria-label": "Show dialog telling about the data",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (showAboutData.value = true)),
                    onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (showAboutData.value = true), ["enter"]))
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode(" About the Data ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, { "aria-label": "Leave Page to Educator Resources" }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_6, [
                        _cache[23] || (_cache[23] = _createTextVNode("Educator Resources", -1)),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                            _createTextVNode("mdi-open-in-new", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    tabindex: "0",
                    "aria-label": "Show credits",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (showCredits.value = true)),
                    onKeyup: _cache[13] || (_cache[13] = _withKeys(($event: any) => (showCredits.value = true), ["enter"]))
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode(" Credits ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color"])
    ])
  ]))
}
}

})